<div class="wrapper" [ngStyle]="wrapperStyles">
  <div class="before">
    {{ beforeText | translate }}
  </div>

  <div class="content">
    <ng-content></ng-content>
  </div>

  <div class="after">
    {{ afterText | translate }}
  </div>
</div>
